import script from "./DoctorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__